import { HttpClient, HttpContext } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { resolveTenantUrl, tenantOverrideOptions } from "src/app/Common/ApiConfigurationService/resolve-tenant-url.util";
import {
  GlobalPolicyRulesCreateRequestDTO,
  GlobalPolicyRulesUpdateRequestDTO,
  GlobalPolicyRulesDeleteRequestDTO,
  GlobalPolicyRulesReadByIdRequestDTO,
  GlobalPolicyRulesReadByTenantIdRequestDTO,
  GlobalPolicyRulesReadByCategoryRequestDTO,
  GlobalPolicyRulesDTO,
  GlobalPolicyRulesList
} from "./global-policy-rules.interface";
import {
  HRMS_GlobalPolicyRules_Create,
  HRMS_GlobalPolicyRules_Update,
  HRMS_GlobalPolicyRules_Delete,
  HRMS_GlobalPolicyRules_ReadById,
  HRMS_GlobalPolicyRules_ReadByTenantId,
  HRMS_GlobalPolicyRules_ReadByCategory
} from "src/app/GlobalVariables";

@Injectable({
  providedIn: 'root'
})
export class GlobalPolicyRulesService {
  http = inject(HttpClient);

  GlobalPolicyRules_Create(data: GlobalPolicyRulesCreateRequestDTO): Observable<GlobalPolicyRulesDTO> {
    return this.http.post<GlobalPolicyRulesDTO>(HRMS_GlobalPolicyRules_Create, data);
  }

  GlobalPolicyRules_Update(data: GlobalPolicyRulesUpdateRequestDTO): Observable<GlobalPolicyRulesDTO> {
    return this.http.post<GlobalPolicyRulesDTO>(HRMS_GlobalPolicyRules_Update, data);
  }

  GlobalPolicyRules_Delete(data: GlobalPolicyRulesDeleteRequestDTO): Observable<GlobalPolicyRulesDTO> {
    return this.http.post<GlobalPolicyRulesDTO>(HRMS_GlobalPolicyRules_Delete, data);
  }

  GlobalPolicyRules_ReadById(data: GlobalPolicyRulesReadByIdRequestDTO): Observable<GlobalPolicyRulesDTO> {
    return this.http.post<GlobalPolicyRulesDTO>(HRMS_GlobalPolicyRules_ReadById, data);
  }

  // baseUrlOverride (optional, both methods): the viewed tenant's own HRMS
  // gateway origin, e.g. CompanyDetailComponent.apiConfigOverride.HRMS.
  // Omitted for every other caller (e.g. uiconfig's Global Policy screen) -
  // behaves exactly as before.
  GlobalPolicyRules_ReadByTenantId(data: GlobalPolicyRulesReadByTenantIdRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<GlobalPolicyRulesList> {
    return this.http.post<GlobalPolicyRulesList>(resolveTenantUrl(HRMS_GlobalPolicyRules_ReadByTenantId, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
  }

  GlobalPolicyRules_ReadByCategory(data: GlobalPolicyRulesReadByCategoryRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<GlobalPolicyRulesList> {
    return this.http.post<GlobalPolicyRulesList>(resolveTenantUrl(HRMS_GlobalPolicyRules_ReadByCategory, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
  }

}
